/**
 * 같은 화면 프레임 안에 여러 번 들어온 값 중 마지막 값만 한 번 반영한다.
 * 스트리밍 본문은 매 청크가 누적 전체 글이라 마지막 값만 그려도 같다.
 * - flush(): 기다리던 값을 지금 바로 반영하고 예약을 지운다. 다른 이벤트·완료·오류를 처리하기 전에 불러
 *   순서를 지킨다(완료 뒤에 늦은 '작성 중' 상태가 덮어쓰지 않게).
 * - cancel(): 기다리던 값을 버린다.
 */
export const createLatestFrameBatcher = (apply) => {
  const hasRaf = typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function';
  const request = hasRaf ? (cb) => window.requestAnimationFrame(cb) : (cb) => setTimeout(cb, 16);
  const release = hasRaf ? (id) => window.cancelAnimationFrame(id) : (id) => clearTimeout(id);

  let handle = null;
  let hasPending = false;
  let pending;

  const run = () => {
    handle = null;
    if (!hasPending) return;
    const value = pending;
    hasPending = false;
    pending = undefined;
    apply(value);
  };

  const stop = () => {
    if (handle !== null) {
      release(handle);
      handle = null;
    }
  };

  return {
    schedule(value) {
      pending = value;
      hasPending = true;
      if (handle === null) handle = request(run);
    },
    flush() {
      stop();
      run();
    },
    cancel() {
      stop();
      hasPending = false;
      pending = undefined;
    },
  };
};
